import { render, staticRenderFns } from "./PlanningEntryList.vue?vue&type=template&id=65171e32&scoped=true&"
import script from "./PlanningEntryList.vue?vue&type=script&lang=ts&"
export * from "./PlanningEntryList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65171e32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
